import React from 'react';

import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';

import usePromoMeta from '~/components/Promo/hooks/usePromoMeta';
import StandaloneMultiProductOptionSelect from '~/components/PromoV3/StandaloneMultiProductOptionSelect';

type ProductMultiSelectProps = GridRenderEditCellParams & {
  promoProductTypes: ReturnType<typeof usePromoMeta>['promoMeta']['promo_product_types'];
  multiSelectType: 'products' | 'min_spend_products';
  disabled?: boolean;
};

export function ProductMultiSelectEditCell({
  id,
  field,
  value,
  promoProductTypes,
  multiSelectType,
  disabled = false,
  ...props
}: ProductMultiSelectProps) {
  const apiRef = useGridApiContext();
  return (
    <StandaloneMultiProductOptionSelect
      productContext="voucher"
      {...props}
      id={`${String(id)}-${field}`}
      value={Array.isArray(value) ? value : []}
      promoProductTypes={promoProductTypes}
      multiSelectType={multiSelectType}
      disabled={disabled}
      onChange={(newValue) => {
        if (disabled) {
          return;
        }
        apiRef.current.setEditCellValue({ id, field, value: newValue });
      }}
    />
  );
}
